import { storage } from "../../app/setup/storage/storage"
import { v4 as uuidv4 } from 'uuid';

export function getVisitorId(): string {
  const id = storage.getVisitorId()
  if (!id) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    const visitorId = uuidv4()

    storage.setVisitorId(visitorId)
    return visitorId
  } else {
    return id
  }
}
export function persistVisitorId(visitorId: string) {
  storage.setVisitorId(visitorId)
}
